export enum UserStatus {
    active = 'active',
    inActive = 'inactive',
    deleted = 'deleted',
}
